import { useEffect, useRef } from 'react'
import { useLocation, useNavigationType } from 'react-router-dom'
import { useSound } from './useSound'

/**
 * Plays the transition cue whenever the route changes.
 *
 * Renders nothing; it exists because the provider sits above the router and
 * therefore cannot use router hooks itself.
 *
 * A back or forward navigation gets the descending figure, so the sound
 * tells you which direction you moved through your own history — the same
 * convention a game uses for entering and leaving a menu.
 *
 * The query string is ignored on purpose: changing a filter on the work
 * index is not arriving somewhere new, and the filter plays its own, lighter
 * cue.
 */
export const RouteSound = () => {
  const { pathname } = useLocation()
  const navigationType = useNavigationType()
  const { play } = useSound()
  const previous = useRef<string | null>(null)

  useEffect(() => {
    // Skip the first render: arriving on the site is the title cue's job.
    if (previous.current === null) {
      previous.current = pathname
      return
    }
    if (previous.current === pathname) return
    previous.current = pathname

    play(navigationType === 'POP' ? 'back' : 'navigate')
  }, [pathname, navigationType, play])

  return null
}
